"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptions = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var deepmerge_1 = __importDefault(require("deepmerge"));
var react_1 = __importDefault(require("react"));
var core_1 = require("../../shared/core");
var registers_1 = require("../../shared/core/utils/registers");
var analytics_subjects_1 = require("./analytics-subjects");
var Abbr_1 = require("./components/Abbr");
function TeleswitchInfoLink(_a) {
    var children = _a.children;
    var TextLink = (0, core_1.useComponents)().TextLink;
    var teleswitchInfo = (0, core_1.useLinks)().teleswitchInfo;
    return (react_1.default.createElement(TextLink, { opensInNewWindow: true, href: teleswitchInfo() }, children));
}
function RenewalLink(_a) {
    var children = _a.children;
    var TextLink = (0, core_1.useComponents)().TextLink;
    var renewal = (0, core_1.useLinks)().renewal;
    return (react_1.default.createElement(TextLink, { href: "".concat(renewal(), "?utm_source=my-plan") }, children));
}
function KwhAbbr(_a) {
    var children = _a.children;
    var copy = (0, core_1.useCopy)({
        keys: { kwhFull: 'common.kwhFull' },
        defaultTranslations: core_1.translations,
    }).copy;
    return react_1.default.createElement(Abbr_1.Abbr, { ariaLabel: copy('kwhFull') }, children);
}
var ContactUsLink = function (_a) {
    var _b;
    var children = _a.children;
    var TextLink = (0, core_1.useComponents)().TextLink;
    var contactUs = (0, core_1.useLinks)().contactUs;
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.CONTACT_US_LINK, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(TextLink, { href: contactUs() }, children)));
};
function CapitalisedRegisterLabel(_a) {
    var friendlyLabel = _a.friendlyLabel;
    return react_1.default.createElement(registers_1.RegisterLabel, { friendlyLabel: friendlyLabel, capitalise: true });
}
var keys = {
    contractDetails: 'plan.contractDetails',
    contractEndDateLabel: 'plan.contractEndDateLabel',
    contractNameLabel: 'plan.contractNameLabel',
    contractStartDateLabel: 'plan.contractStartDateLabel',
    exitFeeCharge: 'plan.exitFeeCharge',
    exitFeeLabel: 'plan.exitFeeLabel',
    sprnElecFull: 'common.sprnElecFull',
    sprnElecLabel: 'common.sprnElec',
    sprnGasFull: 'common.sprnGasFull',
    sprnGasLabel: 'common.sprnGas',
    msn: 'common.msn',
    msnLabel: 'common.msnFull',
    namedUnitRateLabel: 'plan.namedUnitRateLabel',
    clockingHoursStayOnGmt: 'plan.clockingHoursStayOnGmt',
    clockingHoursChangeForBst: 'plan.clockingHoursChangeForBst',
    teleswitchMeterInfo: 'plan.teleswitchMeterInfo',
    noActiveEnergyPlan: 'plan.noActiveEnergyPlan',
    noExitFees: 'plan.noExitFees',
    noExitFeesRenewal: 'plan.noExitFeesRenewal',
    priceAndUnitRates: 'plan.priceAndUnitRates',
    projectedAnnualConsumption: 'plan.projectedAnnualConsumption',
    projectedAnnualConsumptionLabel: 'plan.projectedAnnualConsumptionLabel',
    projectedAnnualConsumptionLabelWithRate: 'plan.projectedAnnualConsumptionLabelWithRate',
    standingCharge: 'plan.standingCharge',
    standingChargeLabel: 'plan.standingChargeLabel',
    title: 'plan.title',
    unitRate: 'plan.unitRate',
    unitRateLabel: 'plan.unitRateLabel',
    registerUnitRateLabel: 'plan.registerUnitRateLabel',
    variableContractEndDate: 'plan.variableContractEndDate',
    electricity: 'plan.electricity',
    gas: 'plan.gas',
};
var defaultTranslations = (0, deepmerge_1.default)(core_1.translations, {
    en: {
        plan: {
            contractDetails: 'Contract details',
            contractEndDateLabel: 'Contract end date',
            contractNameLabel: 'Plan name',
            contractStartDateLabel: 'Contract start date',
            exitFeeCharge: '{{formattedExitFee}} subject to T&Cs.',
            exitFeeLabel: 'Exit fee',
            namedUnitRateLabel: 'unit rate',
            clockingHoursStayOnGmt: 'These hours will be 1 hour later during British Summer Time',
            clockingHoursChangeForBst: 'These same hours apply during both GMT and BST',
            teleswitchMeterInfo: 'You have a Teleswitch meter, <TeleswitchInfoLink>click here for information</TeleswitchInfoLink>.',
            noActiveEnergyPlan: '<P>You currently have no active energy plan.</P><P><ContactUsLink>Contact us</ContactUsLink> if you think this is wrong.</P>',
            noExitFees: 'There are no exit fees to pay on this contract.',
            noExitFeesRenewal: 'There are no exit fees to pay in your <RenewalLink>renewal window</RenewalLink>.',
            priceAndUnitRates: 'Prices and unit rates',
            projectedAnnualConsumption: '{{annualConsumption}} $t(common.kwhUnit)',
            projectedAnnualConsumptionLabel: 'Future annual consumption',
            projectedAnnualConsumptionLabelWithRate: 'future annual consumption',
            standingCharge: '{{ formattedStandingCharge }} per day',
            standingChargeLabel: 'Standing charge',
            title: 'Your Plan',
            unitRate: '{{formattedUnitRateValue}} per <KwhAbbr>$t(common.kwhUnit)</KwhAbbr>',
            unitRateLabel: 'Unit rate',
            registerUnitRateLabel: "<CapitalisedRegisterLabel /> unit rate",
            variableContractEndDate: 'Rolling variable plan',
            electricity: 'Electricity',
            gas: 'Gas',
            controlledLoadRateLabel: 'Controlled load',
            offpeakRateLabel: 'Off-peak',
            peakRateLabel: 'Peak',
            solarRateLabel: 'Solar',
            anytimeRateLabel: 'Anytime',
            unknownRateLabel: 'Other',
        },
    },
});
var defaultOptions = {
    keys: keys,
    defaultTranslations: defaultTranslations,
    components: {
        ContactUsLink: ContactUsLink,
        RenewalLink: RenewalLink,
        KwhAbbr: KwhAbbr,
        TeleswitchInfoLink: TeleswitchInfoLink,
        CapitalisedRegisterLabel: CapitalisedRegisterLabel,
    },
};
exports.defaultOptions = defaultOptions;
